/**************************************************************************************************/
/*   File: /src/app/shared/services/utils/plan.types.service.ts                                   */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { environment } from '../../../../environments/environment';
import { getCurrentLanguage } from '../../../stores/selectors/ui/selectors';
import { RootState } from '../../../stores/states/root/state';
import * as fromModels from '../../models';

/**
 * The plan types service
 */
@Injectable({
  providedIn: 'root'
})
export class PlanTypesService {
  /**
   * The api url for authorization users
   */
  apiUrl = environment.serviceHost;
  /**
   * The api path
   */
  apiPath = environment.apiPath;
  /**
   * The geo data type api url
   */
  planTypes = 'planTypes';
  /**
   * The current lang
   */
  currentLang: string;

  /**
   * The constructor
   * Store will be replaced when proxy is set
   * Because headers will be set by him
   */
  constructor(private http: HttpClient, private logger: NGXLogger, private store: Store<RootState>) {
    // Due to testing pipeable operator
    // tslint:disable-next-line
    this.store.select(
      getCurrentLanguage
    ).subscribe((language) => {
      this.currentLang = language.isoCode === 'en' ? environment.defaultLanguage : language.isoCode;
    });
  }

  /**
   * Get plan types
   */
  getPlanTypes(): Observable<fromModels.PlanType[]> {
    return this.http.get<fromModels.PlanType[]>(`${this.apiUrl}${this.apiPath}piani-territoriali-enabled-to-portal`, {
      headers: {
        'X-NewPlan-Locale': this.currentLang
      }
    });


  }


}
